var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransparentPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.71002 13.5012H0.5V11.2912L8.60745 3.18367L10.8175 5.39369L2.71002 13.5012Z",
    stroke: "#3CB4E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3488 3.86111L10.1387 1.65109L11.2088 0.581089C11.3169 0.47297 11.4943 0.47297 11.6024 0.581089L11.6024 0.581093L13.4188 2.39747C13.4188 2.39747 13.4188 2.39748 13.4188 2.39748C13.5269 2.50559 13.5269 2.68297 13.4188 2.79108L13.4188 2.79111L12.3488 3.86111Z",
    stroke: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparentPencilIcon);
export default __webpack_public_path__ + "static/media/transparentPencilIcon.30bae0f8184c113e958b0ee1ffb58d83.svg";
export { ForwardRef as ReactComponent };